module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"phrase":"Helping traders to get more targets"},"es":{"phrase":"Ayudando traders a alcanzar más targets"}}')
  delete Component.options._Ctor
}
